import {HttpCli as HttpCliV2} from "yichen_encrypt";
export default class HttpCli {
  static req(url, data) {
    return HttpCliV2.req({url, data})
  }

  static download(url, data) {
    return HttpCliV2.download({url, data})
  }

  static uploadFile (url, data) {
    return HttpCliV2.uploadFile({url, data})
  }
}
